import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from '@/components/Button';
import Dialog, {
	DialogContent,
	DialogFooter,
	DialogTop
} from '@/components/DialogSheet';
import { STORAGE_DAYS } from '@/config';
import { useHasStorageCharge, useIsTrialing } from '@/hooks/user';
import routes from '@/routes';
import { setIsModalTimerOpen } from '@/store/myDocuments';

import { BILLING_TAB } from '../Account/constants';

function ModalTimer() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const hasStorageCharge = useHasStorageCharge();
	const isTrialing = useIsTrialing();
	const open = useSelector(state => state.myDocuments.isModalTimerOpen);
	const { t } = useTranslation();

	const handleOpenChange = value => dispatch(setIsModalTimerOpen(value));
	const handleClose = () => handleOpenChange(false);

	const textDescription = hasStorageCharge
		? t('myDocuments.timerDescriptionStorage', {
				storageDays: STORAGE_DAYS
			})
		: t('myDocuments.timerDescription');

	return (
		<Dialog open={open} onOpenChange={handleOpenChange}>
			<DialogContent className="w-full p-0 sm:w-[397px]">
				<DialogTop
					className="font-sans text-sm leading-6"
					description={textDescription}
					title={t('myDocuments.timerTitle')}
				/>
				<div className="px-9 py-9">
					<p className="text-center text-sm leading-6 text-gray-500">
						{textDescription}
					</p>
				</div>
				<DialogFooter className="flex justify-between">
					<Button
						className="w-full"
						onClick={handleClose}
						type="button"
						variant="outline"
					>
						{t('common.cancel')}
					</Button>
					<Button
						className="w-full"
						onClick={() => {
							navigate(routes.myAccount, {
								state: {
									openChangePlanModal: isTrialing,
									currentTab: BILLING_TAB
								}
							});
							handleClose();
						}}
						type="button"
					>
						{t('myDocuments.timerAction')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}

export default ModalTimer;
